// extracted by mini-css-extract-plugin
module.exports = {"active":"technology-module--active--ntROQ","passive":"technology-module--passive--FEB4Y","item":"technology-module--item--2DDz7"};